import { EventTarget, SpriteFrame } from 'cc';
import RemoteLoader from '../../../../../../common/scripts/Toolkit/Helper/Loading/RemoteLoader';
import DataType from '../../Config/DataStructure';
import { IAssetInfoData, ICommonOverviewData, ICommonStatsData } from '../../Config/GamePreviewDataType';
import { MachineState } from '../../Model/TableModel';

enum EventType {
    MACHINE_STATE_CHANGED = 'MACHINE_STATE_CHANGED',
    FAVORITE_STATUS_CHANGED = 'FAVORITE_STATUS_CHANGED',
    IMAGE_CHANGED = 'IMAGE_CHANGED',
    OVERVIEW_DATA_CHANGED = 'OVERVIEW_DATA_CHANGED',
    STATS_DATA_CHANGED = 'STATS_DATA_CHANGED',
}

export default class CommonGamePreviewData extends EventTarget implements ICommonOverviewData, ICommonStatsData {
    public static readonly EVENT_TYPE = EventType;

    protected _asset: IAssetInfoData = null;
    // HACK
    protected readonly _hallID: number = -1;
    protected readonly _gameID: string = '';
    protected readonly _gameType: DataType.Enums.PlayType;
    protected _logo: SpriteFrame = null;
    protected _isEnabled: boolean = true;
    protected _state: MachineState = MachineState.Ready;

    constructor(hallID: number, gameID: string, gameType: DataType.Enums.PlayType, data: ICommonOverviewData) {
        super();
        this._hallID = hallID;
        this._gameType = gameType;
        this._gameID = gameID;
        this.Asset = data.Asset;
        this.Enabled = data.Enabled;
    }

    public get key() {
        return CommonGamePreviewData.createKey(this._hallID, this._gameID, this._gameType);
    }

    public get HallID() {
        return this._hallID;
    }

    public get GameID() {
        return this._gameID;
    }

    public get GameType() {
        return this._gameType;
    }

    public get Asset() {
        return this._asset;
    }
    protected set Asset(value: IAssetInfoData) {
        this._asset = value;
        this.loadImage();
    }

    public get Enabled() {
        return this._isEnabled;
    }
    protected set Enabled(value: boolean) {
        if (this._isEnabled === value) {
            return;
        }
        this._isEnabled = value;
        this.state = this._isEnabled ? MachineState.Ready : MachineState.Maintenance;
    }

    public get state() {
        return this._state;
    }
    public set state(value: MachineState) {
        if (value === this._state) {
            return;
        }
        this._state = value;
        this.emit(CommonGamePreviewData.EVENT_TYPE.MACHINE_STATE_CHANGED, this._state);
    }

    public static createKey(hallID: number, gameID: string, gameType: DataType.Enums.PlayType) {
        return `${hallID}-${gameID}-${gameType}`;
    }

    public getImage() {
        if (!this._logo) {
            this.loadImage();
        }
        return this._logo;
    }

    public updateOverviewData(data: ICommonOverviewData) {
        this.Asset = data.Asset;
        this.Enabled = data.Enabled;
        this.emit(CommonGamePreviewData.EVENT_TYPE.OVERVIEW_DATA_CHANGED);
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    public updateStatsData(data: ICommonStatsData) {
        this.emit(CommonGamePreviewData.EVENT_TYPE.STATS_DATA_CHANGED);
    }

    public updateGameDenom() {}

    protected async loadImage() {
        if (this._asset?.Logo) {
            const image = await RemoteLoader.loadSpriteFrame(this._asset.Logo);
            if (this._logo === image) {
                return;
            }
            this._logo = image;
            this.emit(CommonGamePreviewData.EVENT_TYPE.IMAGE_CHANGED, this._logo);
        }
    }
}
